module.exports = __webpack_public_path__ + "static/media/Rebecca.0375f0a9.png";